import React from "react"
import { Link } from "react-router-dom"

const SectionThree = () => {
  return (
    <div className="mobiles:mt-60 global-container py-20 mobiles:pb-4 text-center">
      <h4 className="text-5xl mobiles:hidden sabi-header">
        The right{" "}
        <span className="header-bg-design sabi-header">gift for every</span>{" "}
        occassion
      </h4>
      <h4 className="text-4xl mobiles:block hidden sabi-header">
        The right gift for <br />
        eve<span className="header-bg-design sabi-header">ry occass</span>ion
      </h4>
      <p className="mt-4 text-xl">Our Store Carries Over 1,000 Top Brands</p>
      <div className="mt-32 mobiles:mt-20 grid grid-cols-4 mobiles:grid-cols-2 gap-6 h-30vh">
        <div
          style={{ backgroundColor: "#c6ddf8" }}
          className="h-full rounded-lg flex mobiles:py-6 items-center justify-center"
        >
          <div className="w-1/2 mx-auto text-center ">
            <img
              src={require("../../assets/speaker.svg").default}
              className="block w-full"
              alt=""
            />
          </div>
        </div>
        <div
          style={{ backgroundColor: "#F5E5DE" }}
          className="h-full rounded-lg flex mobiles:py-6 items-center justify-center"
        >
          <div className="w-3/5 mx-auto text-center ">
            <img
              src={require("../../assets/macbook.svg").default}
              className="block w-full"
              alt=""
            />
          </div>
        </div>
        <div
          style={{ backgroundColor: "#DDD6E8" }}
          className="h-full bg-sbg-h-b rounded-lg flex mobiles:py-6 items-center justify-center"
        >
          <div className="w-1/2 mx-auto text-center ">
            <img
              src={require("../../assets/headset.svg").default}
              className="block w-full"
              alt=""
            />
          </div>
        </div>
        <div
          style={{ backgroundColor: "rgba(255, 168, 76, 0.5)" }}
          className="h-full bg-sbg-h-b rounded-lg flex mobiles:py-6 items-center justify-center"
        >
          <div className="w-1/2 mx-auto text-center ">
            <img
              src={require("../../assets/wrist-watch.svg").default}
              className="block w-full"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="mt-28 mobiles:mt-48">
        <Link
          to="/find-registry"
          className=" py-2.5 px-11 ml-4 border border-sbg-pink text-sbg-pink text-transparent rounded-md text-base"
        >
          View our registry
        </Link>
      </div>
    </div>
  )
}

export default SectionThree
